import { createClient } from "@supabase/supabase-js";
import { Database } from "./types/supabase";
import { httpClient } from "./clients/http-client";
import { LocalStorageOperations } from "../../../data/storage/LocalStorageOperations";
import WooComAPI from "../../../providers/WooComAPI/woo-com-api";

const supabaseUrl = process.env.REACT_APP_PARHATO_2_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_PARHATO_2_SUPABASE_ANON_KEY!;
export const supabaseClient = createClient<Database>(supabaseUrl, supabaseAnonKey);

supabaseClient.auth.onAuthStateChange((event, session) => {
  if (session) {
    httpClient.token = session.access_token;
    WooComAPI.setAccessToken(session.access_token);

    if (event === "TOKEN_REFRESHED") {
      LocalStorageOperations.updateUserInfo({
        token: session.access_token,
        supabaseAuth: { accessToken: session.access_token, refreshToken: session.refresh_token },
      });
    }
  } else {
    httpClient.token = undefined;
  }
});
